import React from 'react';
export default class ConfirmDeleteLocationForm extends React.Component {
    render() {
        return (
            <div>
                <div className={"modals__overlay" + (this.props.isConfirmingDeleteLocation ? "" : " closed")} onClick={this.props.closeConfirmDeleteLocationForm}></div>
                <div className={"modals__content " + (this.props.isConfirmingDeleteLocation ? "" : " closed")}>
                    <div className="modals__content__header">
                        <button className="close" onClick={this.props.closeConfirmDeleteLocationForm} type="button" data-dismiss="modal" aria-hidden="true">×</button>
                        <h4 className="modals__content__header__title">Confirm Delete Location</h4>
                    </div>
                    <div className="modals__content__body delete-user-wrapper">
                        <p>Chosen location {this.props.type ? 'and all related data ' : ''}will be deleted !</p>
                    </div>
                    <div className="modals__content__footer">
                        <button className="btn btn-default" onClick={this.props.closeConfirmDeleteLocationForm} type="button" data-dismiss="modal">Cancel</button>
                        <button className="btn btn-danger" onClick={() => {
                            this.props.submit(this.props.node);
                            this.props.closeConfirmDeleteLocationForm();
                        }} type="button">OK</button>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/pages/locations/modalformcomponents/confirmdeletelocation.jsx